import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})

export class DropdownComponent {
  @Input() valueDropdown: any;
  @Input() title: any;
  @Output()
  selected = new EventEmitter()

  displayText

  constructor() { }

  onSelectValue(select) {
    this.displayText = select.value
    this.selected.emit(select.id)
  }

  ngAfterContentInit(): void {

    this.displayText = this.title
  }

}
